import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { getMyTrialDaysFn } from "@/lib/payments.functions";
import { useAuth } from "@/hooks/use-auth";
import { getStripeEnvironment } from "@/lib/stripe";

export const DEFAULT_TRIAL_DAYS = 30;

/**
 * Trial length to *show* in copy: 30 normally, 60 for accounts created through
 * an eligible referral code. Signed-out visitors (public /pricing) and the
 * loading state fall back to 30 so the label never flickers a wrong number
 * upward. Stripe still decides the real length server-side at checkout.
 */
export function useTrialDays(): { trialDays: number; firstChargeDay: number; loading: boolean } {
  const { user } = useAuth();
  const fetchTrialDays = useServerFn(getMyTrialDaysFn);

  const { data, isLoading } = useQuery({
    queryKey: ["my-trial-days", user?.id, getStripeEnvironment()],
    enabled: !!user,
    staleTime: 5 * 60 * 1000,
    queryFn: () => fetchTrialDays({ data: { environment: getStripeEnvironment() } }),
  });

  const resolved = data?.trialDays;
  const trialDays = resolved && resolved > 0 ? resolved : DEFAULT_TRIAL_DAYS;

  return { trialDays, firstChargeDay: trialDays + 1, loading: !!user && isLoading };
}
